// extracted by mini-css-extract-plugin
module.exports = {"templateCard":"sendEmailModal_templateCard__mPrZx"};